module.exports = __webpack_public_path__ + "static/media/pdo04.2af5e4bd.jpg";